import { render } from "./RumaFilter.vue?vue&type=template&id=00a13a6e&scoped=true&ts=true"
import script from "./RumaFilter.vue?vue&type=script&lang=ts"
export * from "./RumaFilter.vue?vue&type=script&lang=ts"

import "./RumaFilter.vue?vue&type=style&index=0&id=00a13a6e&scoped=true&lang=css"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a13a6e"]])

export default __exports__